import React from 'react';
import { Box, Text } from '@rsos/components/capstone/base';

const NoSearchResult = () => {
  return (
    <Box align="center" justify="center" height="100%" pb={'50px'}>
      <Box align="center" justify="center">
        <Text color="primaryText" fontWeight="bold" mb={'12px'}>
          No Results
        </Text>
        <Text color="primaryText" size="small">
          No results have been found.
        </Text>
      </Box>
    </Box>
  );
};

export default NoSearchResult;
